import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmailIcon from "@mui/icons-material/Email";
import ForumIcon from "@mui/icons-material/Forum";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import {
  Checkbox,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Slide,
  TextField,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as GroupChatFilled } from "../../../Assets/img/icons/group-chat-figma.svg";
import { ReactComponent as VideoCallFilled } from "../../../Assets/img/icons/video-call-figma.svg";
import { ReactComponent as VideoTutorialFilled } from "../../../Assets/img/icons/video-tutorial-figma.svg";
import { ReactComponent as WhatsappFilled } from "../../../Assets/img/icons/whatsapp-filled.svg";
import person1 from "../../../Assets/img/person1.svg";
import person2 from "../../../Assets/img/person2.svg";
import person3 from "../../../Assets/img/person3.svg";
import person4 from "../../../Assets/img/person4.svg";
import {
  getAllFoldersReducer,
  getConnectedReducer,
  getSelectedFolderReducer,
  getContactGroupReducer,
  getUserFolderDetailsReducer
} from "../../../Redux/Reducers/ContactReducer";
import ContactsSkeleton from "../../LoadingSkeleton/ContactsSkeleton";
import { useQuantityContext } from "../../QuantityContext";
import { useUserDetailContext } from "../../UserDetailContext";
import useApi from "../../Utilities/useAPI";
// import AgoraVideoCall from "./AgoraVideoCall";
import CreateGroupCallModal from "./CreateGroupCallModal";
import SpeedDialComponent from "./SubPages_Contacts/SpeedDialComponent";

const personsData2 = [
  { img: person1, name: "Person 1" },
  { img: person2, name: "Person 2" },
  { img: person3, name: "Person 3" },
  { img: person4, name: "Person 4" },
];

function Contacts({ onStartVideoCall }) {
  // console.log("IAM from CALL", onStartVideoCall)
  const { sortOrder, sortDateOrder, latestDateOrder } = useQuantityContext();
  const [selectedFolderIds, setSelectedFolderIds] = useState([]);
  // const [showSubmenu, setShowSubmenu] = useState(false);
  const { callApiFunction } = useApi();
  // const { ConnectedContacts, unVerifiedCount, UnverifiedContacts, groupsAll, favouriteContacts } = useContext(ContactsDetContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  // console.log("selectedFolderIdsNNN", selectedFolderIds);

  const [ConnectedContacts, setConnectedContacts] = useState([]);
  const [unVerifiedCount, setUnVerifedCount] = useState([]);
  const [UnverifiedContacts, setUnverifiedContacts] = useState([]);
  const [favouriteContacts, setFavoriteContacts] = useState([]);
  const [groupsAll, setGroupsAll] = useState([]);

  // console.log("groupsAll+", groupsAll)

  const [groups, setGroups] = useState([
    { id: -1, name: "All Contacts", member_count: 0, persons: personsData2 },
    { id: -2, name: "Favourite Contacts", member_count: 0, persons: [] },
  ]);
  const [isCreateGroupCallModalOpen, setIsCreateGroupCallModalOpen] =
    useState(false);
  const [isVideoCallActive, setIsVideoCallActive] = useState(false);
  const [callData, setCallData] = useState(null);
  const { userDetails } = useUserDetailContext();
  const [incomingCall, setIncomingCall] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [showOptionsBar, setShowOptionsBar] = useState(false);
  const [selectAllContacts, setSelectAllContacts] = useState(false);
  const currentUserId = userDetails?.reference_id;
  const [selectedFolderContacts, setSelectedFolderContacts] = useState([]);
  const selectedFolder = useSelector(
    (state) => state?.ContactArray?.selectedFolder
  );

  // console.log("selectedFolder123", selectedFolder);

  const formatGroupsData = (folders) => {
    return folders.map((folder) => ({
      id: folder.id,
      name: folder.folder_name,
      member_count: folder?.member_count,
      persons: (folder.member_profile_urls || []).slice(0, 6).map((entry) => ({
        img: entry.startsWith("http") ? entry : null, // use as image only if it's a URL
        name: entry.length === 1 ? entry : null, // fallback label if it's a single letter
      })),
    }));
  };

  const getGroupLink = (name) => {
    switch (name) {
      case "All Contacts":
        return "/AllContacts_groups";
      case "Unverified Contacts":
        return "/Unverified_Contacts";
      case "Favourite Contacts":
        return "/favourite_contacts";
      default:
        return `/Card_ConnectedMember/${name}`;
    }
  };

  const getGroupLinkById = (name) => {
    switch (name) {
      case "All Contacts":
        return "/AllContacts_groups";
      case "Unverified Contacts":
        return "/Unverified_Contacts";
      case "Favourite Contacts":
        return "/favourite_contacts";
      default:
        return `/Card_ConnectedMember/${name}`;
    }
  };

  const handleFolderClick = (folderId) => {
    // Set only the clicked folder ID (single selection)
    setSelectedFolderIds([folderId]);

    // Find the selected folder from allFolders
    const selectedFolder = allFolders?.find((f) => f.id === folderId);

    // Dispatch the selected folder to Redux
    dispatch(getSelectedFolderReducer(selectedFolder));

    navigate(`/contacts/folder/${folderId}`);
  };

  const Folders = useSelector(
    (state) => state?.ContactArray?.UserFolderDetails
  );
  const Connectedcontact = useSelector(
    (state) => state?.ContactArray?.ConnectedContact
  );
  const ContactGroups = useSelector(
    (state) => state?.ContactArray?.ContactGroup
  );
  const allFolders = useSelector((state) => state?.ContactArray?.allFolders);

  // console.log("ContactGroupsNNN", ContactGroups)

  useEffect(() => {
    dispatch(getConnectedReducer());
  }, []);

  useEffect(() => {
    const handleIncomingCall = (event) => {
      const { caller, meetingName, rtcToken, uid, to } = event.detail;
      // Only show if current user is invited
      if (currentUserId === to) {
        setIncomingCall({ caller, meetingName, rtcToken, uid });
      }
    };

    window.addEventListener("incoming-call", handleIncomingCall);
    return () =>
      window.removeEventListener("incoming-call", handleIncomingCall);
  }, [currentUserId]);

  // useEffect(() => {
  //   const processContacts = async () => {
  //     try {
  //       const members = Connectedcontact.map((member) => ({
  //         ...member,
  //         id: member.id,
  //         contact_ref_id: member.contact_ref_id,
  //         img: member.profile_url,
  //         is_favourite: member?.is_favourite ? true : false,
  //         name: `${member.first_name} ${member.last_name}`,
  //         role:
  //           member.designation ||
  //           member.field_of_study ||
  //           member.title ||
  //           "---",
  //         email: `${member.first_name.toLowerCase()}.${member.last_name.toLowerCase()}@example.com`,
  //         verified: member.is_verified ? true : false,
  //         neoin_id: member.unique_id,
  //         subTitle:
  //           member.profession_department ||
  //           member.institute ||
  //           member.nickname ||
  //           "---",
  //       }));

  //       // Improved folder filtering logic
  //       let folderContacts = members;
  //       if (selectedFolderIds.length > 0) {
  //         folderContacts = [];
  //         selectedFolderIds.forEach((folderId) => {
  //           const folder = allFolders.find((f) => f.id === folderId);
  //           if (folder) {
  //             if (folder.folder_name === "All Contacts") {
  //               folderContacts = [...members];
  //             } else if (folder.folder_name === "Unverified Contacts") {
  //               folderContacts = [
  //                 ...folderContacts,
  //                 ...members.filter((m) => !m.verified),
  //               ];
  //             } else if (folder.folder_name === "Favourite Contacts") {
  //               folderContacts = [
  //                 ...folderContacts,
  //                 ...members.filter((m) => m.is_favourite),
  //               ];
  //             } else {
  //               // For custom folders, match by folder's member_profile_urls
  //               folderContacts = [
  //                 ...folderContacts,
  //                 ...members.filter((m) =>
  //                   folder.member_profile_urls?.includes(m.img)
  //                 ),
  //               ];
  //             }
  //           }
  //         });
  //         // Remove duplicates
  //         folderContacts = folderContacts.filter(
  //           (v, i, a) => a.findIndex((t) => t.id === v.id) === i
  //         );
  //       }
  //       setSelectedFolderContacts(folderContacts);

  //       setConnectedContacts(members);
  //       const unverifiedMembers = members.filter((member) => !member.verified);
  //       setUnverifiedContacts(unverifiedMembers);
  //       setUnVerifedCount(unverifiedMembers.length);
  //       const favoriteMembers = members.filter((member) => member.is_favourite);
  //       setFavoriteContacts(favoriteMembers);
  //     } catch (err) {
  //       console.log("Error processing contacts:", err);
  //     }
  //   };

  //   processContacts();
  // }, [Connectedcontact, allFolders, selectedFolderIds]);

  useEffect(() => {
    // Fetch contacts from the API
    const fetchContacts = async () => {
      try {
        const members = Connectedcontact.map(member => {
          // Logic for role and subTitle
          const role = member.designation || member.field_of_study || member.title || '---';  // Updated role logic
          const subTitle = member.profession_department || member.institute || member.nickname || '---';  // New subTitle logic

          return {
            id: member.id,
            contact_ref_id: member.contact_ref_id,
            img: member.profile_url,  // Fallback to default image if profile URL is null
            is_favourite: member?.is_favourite ? true : false,
            name: `${member.first_name} ${member.last_name}`,
            role: role,  // Based on new logic
            email: `${member.first_name.toLowerCase()}.${member.last_name.toLowerCase()}@dalocal.com`,  // Mock email as it's not provided
            verified: member.is_verified ? true : false,
            neoin_id: member.unique_id,
            subTitle: subTitle  // Add new subTitle field
          };
        });
        setConnectedContacts(members)
        const unverifiedMembers = members.filter(member => !member.verified);
        setUnverifiedContacts(unverifiedMembers);
        setUnVerifedCount(unverifiedMembers.length);
        // Filter and set favorite contacts
        const favoriteMembers = members.filter(member => member.is_favourite);
        setFavoriteContacts(favoriteMembers);
        // }
      } catch (err) {
        console.log('An error occurred while sending the connection request:', err);
      }
      try {
        // const response = await callApiFunction('fetchGroupDetails');

        // if (response?.statusCode === 200) {
        // console.log("Group Count ijn the contact", response.data);
        // Map the response data to extract group name and URL


        await dispatch(getContactGroupReducer());
        const backendGroups = ContactGroups.map(group => ({
          name: group.group_name,
          url: group.group_url,
          id: group.id,
          group_image: group.group_image,
          // persons: personsData,
          persons: group.members.map(member => ({
            img: member.profile_url, // Use a placeholder if profile_url is null
            name: `${member.first_name} ${member.last_name}`,
          })),
          count: group.count,
        }));

        setGroupsAll(backendGroups);
        // } else {
        // console.log('Error fetching groups:');
        // }
      } catch (error) {
        console.error('Error:', error);
      }

      //   try {
      //     const response = await callApiFunction('getConnectionsMethods');

      //     if (response.statusCode === 200) {
      //       // Map the response data to extract group name and URL
      //       const formattedGroups = formatGroupsData(response.data);
      //       setCardConnectMember(formattedGroups);
      //       console.log("Connection Methds", response);
      //     } else {
      //       console.log('Error fetching groups:');
      //     }
      //   } catch (error) {
      //     console.error('Error:', error);
      //   }

    };

    fetchContacts();
  }, [Connectedcontact]);

  useEffect(() => {
    dispatch(getAllFoldersReducer()); // this just triggers the Redux fetch
  }, []);

  useEffect(() => {
    if (!Array.isArray(allFolders)) return;

    const allContactsFolder = allFolders.find(
      (folder) => folder.folder_name === "All Contacts"
    );
    const unverifiedContactsFolder = allFolders.find(
      (folder) => folder.folder_name === "Unverified Contacts"
    );
    const favouritesFolder = allFolders.find(
      (folder) => folder.folder_name === "Favourite Contacts"
    );

    const formattedGroups = formatGroupsData(
      allFolders.filter(
        (folder) =>
          folder.folder_name !== "All Contacts" &&
          folder.folder_name !== "Unverified Contacts" &&
          folder.folder_name !== "Favourite Contacts"
      )
    );

    setGroups([
      ...(allContactsFolder ? [formatGroupsData([allContactsFolder])[0]] : []),
      ...formattedGroups,
      ...(unverifiedContactsFolder
        ? [formatGroupsData([unverifiedContactsFolder])[0]]
        : []),
      ...(favouritesFolder ? [formatGroupsData([favouritesFolder])[0]] : []),
    ]);

    setLoading(false);
  }, [allFolders]);

  // Ensure `filteredGroups` is included in dependencies

  const handleGroupChange = (event) => {
    const value = event.target.value;

    if (value === "Favourite Contacts") {
      navigate("/favourite_contacts");
    }

    setSelectedGroup(value === "" ? "All Groups" : value);

    // Default to "All Groups" if none is selected
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSelectCheckboxChange = (event) => {
    const checked = event.target.checked;
    if (selectCheckBox) {
      setSelectCheckBox(checked);
      setSelectedGroups([]);
      setSelectAllContacts(false);
    }
    setSelectCheckBox(!selectCheckBox);
  };

  const handleSelectedcontacts = () => {
    setSelectAllContacts((prevSelectAll) => {
      const newSelectAll = !prevSelectAll;

      if (newSelectAll) {
        // Select all folder IDs
        const allFolderIds = groups
          .filter((group) => group.member_count > 0)
          .map((group) => group.id);
        setSelectedFolderIds(allFolderIds);
        setShowOptionsBar(true);
      } else {
        // Deselect all folders
        setSelectedFolderIds([]);
        setShowOptionsBar(false);
      }

      return newSelectAll;
    });
  };

  // const handleGroupSelectChange = (groupName) => (event) => {
  //      event.stopPropagation()
  //     const checked = event.target.checked;
  //     // console.log("checkedNNN", checked)
  //     setSelectedGroups(prevSelectedGroups => {
  //         let newSelectedGroups;

  //         if (checked) {
  //             newSelectedGroups = [...prevSelectedGroups, groupName];
  //         } else {
  //             newSelectedGroups = prevSelectedGroups.filter(name => name !== groupName);
  //         }
  //         // Set the visibility of the options bar
  //         setShowOptionsBar(newSelectedGroups.length > 0);
  //         return newSelectedGroups;
  //     });
  // };

  const handleGroupSelectChange = (folderId) => (event) => {
    event.stopPropagation();
    const checked = event.target.checked;

    setSelectedFolderIds((prev) => {
      let newSelectedIds;

      if (checked) {
        newSelectedIds = [...prev, folderId];
      } else {
        newSelectedIds = prev.filter((id) => id !== folderId);
      }

      // Set the visibility of the options bar
      setShowOptionsBar(newSelectedIds.length > 0);
      return newSelectedIds;
    });
  };

  const getFilteredGroups = () => {
    let filteredGroups = groups;
    // let filteredGroupsdata = groups;

    if (selectedGroup && selectedGroup !== "All Groups") {
      filteredGroups = filteredGroups?.filter(
        (group) => group.name === selectedGroup
      );
    }
    if (searchTerm) {
      filteredGroups = filteredGroups?.filter(
        (group) => group.name.toLowerCase().includes(searchTerm.toLowerCase())
        // || group.persons.some(person => person.name.toLowerCase().includes(searchTerm.toLowerCase()))  // Check persons' names
      );
    }
    return filteredGroups;
  };

  const filteredGroups = getFilteredGroups();

  useEffect(() => {
    if (sortOrder !== null) {
      // Extract group names or the necessary data
      const sortedCards = filteredGroups.sort((a, b) => {
        if (sortOrder === "ascending") {
          return a.name.localeCompare(b.name); // Replace with the correct property
        } else {
          return b.name.localeCompare(a.name); // Replace with the correct property
        }
      });

      // console.log("Sorted Cards:", sortedCards);
    }
  }, [sortOrder, filteredGroups]);

  useEffect(() => {
    if (sortDateOrder !== null) {
      const sortedCards = filteredGroups.sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);

        return sortDateOrder === "ascending" ? dateA - dateB : dateB - dateA;
      });

      // console.log("Sorted by Created Date:", sortedCards);
    }
  }, [sortDateOrder, filteredGroups]);

  useEffect(() => {
    if (latestDateOrder !== null) {
      const sortedCards = filteredGroups.sort((a, b) => {
        const dateA = new Date(a.modified_at);
        const dateB = new Date(b.modified_at);

        return latestDateOrder === "latestDate" ? dateB - dateA : dateA - dateB;
      });

      // console.log("Sorted by Modified Date:", sortedCards);
    }
  }, [latestDateOrder, filteredGroups]); // Add dependencies

  useEffect(() => {
    if (ConnectedContacts.length > 0) {
      setLoading(false);
    }
  }, [ConnectedContacts]);

  if (loading) {
    return <ContactsSkeleton />;
  }

  // const getContactsFromSelectedFolders = () => {
  //     if (selectedFolderIds.length === 0) {
  //         return ConnectedContacts; // Return all contacts if no folders selected
  //     }

  //     let folderContacts = [];

  //     selectedFolderIds.forEach(folderId => {
  //         const folder = allFolders.find(f => f.id === folderId);
  //         if (folder) {
  //             if (folder.folder_name === "All Contacts") {
  //                 folderContacts = [...folderContacts, ...ConnectedContacts];
  //             } else if (folder.folder_name === "Unverified Contacts") {
  //                 folderContacts = [...folderContacts, ...ConnectedContacts.filter(m => !m.verified)];
  //             } else if (folder.folder_name === "Favourite Contacts") {
  //                 folderContacts = [...folderContacts, ...ConnectedContacts.filter(m => m.is_favourite)];
  //             } else if (folder.folder_name === "Verified Contacts") {
  //                 folderContacts = [...folderContacts, ...ConnectedContacts.filter(m => m.verified)];
  //             } else {
  //                 // For custom folders, match by folder's member_profile_urls
  //                 const folderMembers = ConnectedContacts.filter(m =>
  //                     folder.member_profile_urls?.includes(m.img)
  //                 );
  //                 folderContacts = [...folderContacts, ...folderMembers];
  //             }
  //         }
  //     });

  //     // Remove duplicates
  //     return folderContacts.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i);
  // };
  // console.log(
  //   "IAMallFolders",
  //   allFolders,
  //   selectedFolderIds,
  //   ConnectedContacts
  // );
  const getContactsFromSelectedFolders = () => {
    if (selectedFolderIds.length === 0) {
      return ConnectedContacts; // Return all contacts if no folders selected
    }

    let folderContacts = [];

    selectedFolderIds.forEach((folderId) => {
      const folder = allFolders.find((f) => f.id === folderId);
      if (folder) {
        if (folder.folder_name === "All Contacts") {
          folderContacts = [...folderContacts, ...ConnectedContacts];
        } else if (folder.folder_name === "Unverified Contacts") {
          folderContacts = [
            ...folderContacts,
            ...ConnectedContacts.filter((m) => !m.verified),
          ];
        } else if (folder.folder_name === "Favourite Contacts") {
          folderContacts = [
            ...folderContacts,
            ...ConnectedContacts.filter((m) => m.is_favourite),
          ];
        } else if (folder.folder_name === "Verified Contacts") {
          folderContacts = [
            ...folderContacts,
            ...ConnectedContacts.filter((m) => m.verified),
          ];
        } else {
          // For custom folders, match by folder's member_profile_urls
          const folderMembers = ConnectedContacts.filter((m) =>
            folder.member_profile_urls?.includes(m.img)
          );
          folderContacts = [...folderContacts, ...folderMembers];
        }
      }
    });

    // Remove duplicates
    return folderContacts;
  };

  const handleStartCall = (meetingData) => {
    // console.log("meetingDataNNNN", meetingData);
    setCallData(meetingData);
    setIsVideoCallActive(true);
    onStartVideoCall(meetingData); // Call the prop function
  };

  const handleVideoCall = async () => {
    await dispatch(
      getSelectedFolderReducer({
        id: selectedFolderIds[0],
      })
    );

    setIsCreateGroupCallModalOpen(true);
    // console.log("ehloooo", selectedFolder);
  };
  return (
    <>
      {isVideoCallActive ? (""
        // <AgoraVideoCall
        //   meetingName={callData?.meetingName || "Meeting"}
        //   participants={callData?.participants || []}
        //   rtcToken={callData?.rtcToken}
        //   uid={callData?.uid}
        //   onEndCall={() => setIsVideoCallActive(false)}
        //   userId={currentUserId}
        //   selectedFolder={selectedFolder}
        // />
      ) : (
        <div className="outer-layer-of-contacts">
          <motion.div
            // className="flex outer-container"
            className="outer-container-in-Contact"
            initial={{ opacity: 0, y: 50 }} // Start below with opacity 0
            animate={{ opacity: 1, y: 0 }} // Animate to original position and full opacity
            transition={{ duration: 0.8, ease: "easeOut" }} // Adjust duration and easing as needed
          >
            <div className="displayflex justify-content-between align-items-center">
              <h6 className="fw-bold">All Contacts</h6>
              <motion.div
                className="flex-center"
                initial={{ opacity: 0, y: 50 }} // Start below with opacity 0
                animate={{ opacity: 1, y: 0 }} // Animate to original position and full opacity
                transition={{ duration: 0.8, ease: "easeOut" }} // Adjust duration and easing as needed
              >
                <div className="">
                  {/* {selectCheckBox && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectAllContacts}
                          onChange={handleSelectedcontacts}
                        />
                      }
                      label="Select All"
                    />
                  )} */}

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectCheckBox}
                        onChange={handleSelectCheckboxChange}
                      />
                    }
                    label="Select"
                  />
                </div>
                <div style={{ marginRight: "10px" }}>
                  <TextField
                    placeholder="Search..."
                    variant="outlined"
                    size="small"
                    className="me-2"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div className="icon">
                            <FaSearch className="icon-color" />
                          </div>
                        </InputAdornment>
                      ),
                    }}
                    style={{ width: "320px" }}
                  />
                </div>
                <div className="dropdowngroup">
                  <TextField
                    select
                    variant="outlined"
                    size="small"
                    className="mr-2"
                    value={selectedGroup}
                    onChange={handleGroupChange}
                    label="All Folders"
                    style={{ width: "136px" }}
                  >
                    <MenuItem value="All Groups">All Groups</MenuItem>
                    {allFolders
                      ?.filter((group) => group?.member_count > 0)
                      ?.map((group, index) => (
                        <MenuItem key={index} value={group.folder_name}>
                          {group.folder_name}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
              </motion.div>
            </div>

            <div className="mt-4">
              <motion.div
                className="contact-groups"
                initial="hidden"
                animate="visible"
                variants={{
                  visible: { transition: { staggerChildren: 0.4 } },
                  hidden: {},
                }}
              >
                {filteredGroups
                  ?.filter((group) => group?.member_count > 0)
                  ?.map((group, index) => {
                    const persons = group.persons || [];
                    const contactCount = group.member_count || 0;

                    return (
                      <motion.div
                        className={`group ${selectedFolderIds[0] === group.id ? "selected" : ""
                          }`}
                        key={index}
                        onClick={() => {
                          handleFolderClick(group.id);
                        }}
                        variants={{
                          visible: { opacity: 1, y: 0 },
                          hidden: { opacity: 0, y: 20 },
                        }}
                        transition={{ duration: 0.4, ease: "easeOut" }}
                      >
                        <div
                          className="person-box"
                          style={{
                            backgroundColor:
                              group.name === "Unverified Contacts"
                                ? "#EB4E3D61"
                                : undefined,
                          }}
                          onClick={() => {
                            if (!selectCheckBox) {
                              // Only navigate when not in select mode
                              handleFolderClick(group.id);
                            }
                          }}
                        >
                          {/* {selectCheckBox && (
                                                    <Checkbox
                                                        checked={selectedGroups.includes(group.id)}
                                                        onChange={handleGroupSelectChange(group.id)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="group-checkbox"
                                                    />
                                                )} */}

                          {selectCheckBox && (
                            <Checkbox
                              checked={selectedFolderIds.includes(group.id)}
                              onChange={handleGroupSelectChange(group.id)}
                              onClick={(e) => e.stopPropagation()}
                              className="group-checkbox"
                            />
                          )}

                          <Link className="group-link">
                            <div
                              className={`person-grid ${selectCheckBox ? "select-all" : ""
                                }`}
                            >
                              {persons.slice(0, 6).map((person, idx) => (
                                <Avatar
                                  sx={{ width: 32, height: 32 }}
                                  key={idx}
                                  alt={person?.name}
                                  src={person?.img || undefined}
                                >
                                  {person?.name}
                                </Avatar>
                              ))}
                            </div>
                            <div className="person-details fw-bold truncate">
                              {group.name}
                            </div>
                            <div className="person-details-2">
                              {contactCount} Contacts
                            </div>
                          </Link>
                        </div>
                      </motion.div>
                    );
                  })}

                {groupsAll?.length > 0 && (
                  <div className="group">
                    <div className="person-box">
                      {/* {selectCheckBox && (
                                            <Checkbox
                                                checked={selectedGroups.includes(group.name)}
                                                onChange={handleGroupSelectChange(group.name)}
                                                className="group-checkbox"
                                            />
                                        )} */}
                      <Link to="/AllGroup_details" className="group-link">
                        <div
                          className={`person-grid ${selectCheckBox ? "select-all" : ""
                            }`}
                        >
                          {groupsAll.slice(0, 6).map((group, idx) => (
                            <Avatar
                              sx={{ width: 32, height: 32 }}
                              key={idx}
                              alt={group?.name}
                              src={group.group_image} // Keep person image for All Contacts group
                            >
                              {group?.name.charAt(0).toUpperCase()}
                            </Avatar>
                          ))}
                        </div>
                        <div className="person-details fw-bold truncate">
                          All Groups
                        </div>
                        <div className="person-details-2">
                          {groupsAll.length} group
                        </div>
                      </Link>
                    </div>
                  </div>
                )}

                <Slide
                  direction="left"
                  in={showOptionsBar}
                  mountOnEnter
                  unmountOnExit
                >
                  <div
                    className={`group-options-bar ${showOptionsBar === true ? "show-options" : ""
                      }`}
                  >
                    <div className="group-option-box">
                      <VideoCallFilled
                        className="pointer figma-icon"
                        onClick={handleVideoCall}
                      />
                    </div>
                    <div className="group-option-box">
                      <WhatsappFilled className="pointer figma-icon" />
                    </div>
                    <div className="group-option-box">
                      <ForumIcon className="pointer" />
                    </div>
                    <div className="group-option-box">
                      <GroupChatFilled className="pointer figma-icon" />
                    </div>
                    <div className="group-option-box">
                      <AttachFileIcon className="pointer figma-icon" />
                    </div>
                    <div className="group-option-box">
                      <VideoTutorialFilled className="pointer figma-icon" />
                    </div>
                    <div className="group-option-box">
                      <VolumeUpRoundedIcon className="pointer" />
                    </div>
                    <div className="group-option-box">
                      <EmailIcon className="pointer" />
                    </div>
                  </div>
                </Slide>
              </motion.div>

              {/* <CreateGroupCallModal
                                    open={isCreateGroupCallModalOpen}
                                    onClose={() => setIsCreateGroupCallModalOpen(false)}
                                    contacts={[...ConnectedContacts]}
                                    userId={currentUserId}
                                    onStartCall={(meetingName, selectedContacts) => {
                                        setCallData({ meetingName, participants: selectedContacts });
                                        setIsVideoCallActive(true);
                                    }}

                                /> */}

              <CreateGroupCallModal
                open={isCreateGroupCallModalOpen}
                onClose={() => setIsCreateGroupCallModalOpen(false)}
                contacts={selectedFolderContacts} // Use selectedFolderContacts instead of ConnectedContacts
                userId={currentUserId}
                allFolders={allFolders}
                selectedFolderIds={selectedFolderIds}
                selectedFolder={selectedFolder}
                onStartCall={handleStartCall}
              />
            </div>
          </motion.div>
          <SpeedDialComponent />
        </div>
      )}
    </>
  );
}

export default Contacts;
